import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;

  @media (max-width: 840px) {
    padding-top: 0;
  }
`;
